import {Button, Dropdown, DropdownItem} from 'platform/components';
import {Heading, HStack, Icon} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

interface BranchOption {
  value: string;
  label: string;
}

interface RecordAuditBranchSnippetTitleProps extends TestIdProps {
  branchName: string;
  selectedBranchId: string;
  branchOptions: BranchOption[];
  isEditable: boolean;
  onSelect: (branchId: string) => void;
}

/**
 * Branch snippet title: the branch name with an inline dropdown to switch branches
 * (mirrors the paired-record edit affordance). The dropdown persists immediately.
 */
export function RecordAuditBranchSnippetTitle(props: RecordAuditBranchSnippetTitleProps) {
  return (
    <HStack width="100%" spacing={1} align="center" justify="space-between">
      <Heading size={5} headingLevel={6} data-testid={suffixTestId('branchName', props)}>
        {props.branchName}
      </Heading>
      {props.isEditable ? (
        <Dropdown
          placement="bottom-start"
          closeOnSelect
          dropdownControl={
            <Button
              variant="ghostLink"
              size="small"
              leftIcon="image/edit"
              data-testid={suffixTestId('branchEdit', props)}
            />
          }
        >
          {props.branchOptions.map((option) => (
            <DropdownItem
              key={option.value}
              label={option.label}
              onClick={() => props.onSelect(option.value)}
              suffix={
                option.value === props.selectedBranchId ? (
                  <Icon value="action/done" size={4} />
                ) : undefined
              }
              data-testid={suffixTestId(`branchOption-${option.value}`, props)}
            />
          ))}
        </Dropdown>
      ) : null}
    </HStack>
  );
}
